import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useSelector } from "react-redux"

import { isUserAuthenticatedSelector } from "../selectors/AuthSelector"

const PrivateRoute = ({ component: Component, ...rest }) => {
	const authenticated = useSelector(isUserAuthenticatedSelector)
	return (
		<Route
			{...rest}
			render={(props) =>
				authenticated ? (
					<Component {...props} />
				) : (
					<Redirect to="/auth/sign-in" />
				)
			}
		/>
	)
}

export default PrivateRoute
